import { FunctionComponent } from 'react';

// Utilities
import classnames from 'classnames';

// Contexts
import { useViewDetected, ViewMedia } from '@Components/Utils/ViewDetected';

// Components
import Page from '@Components/Utils/Page';
import { InputSearchProps } from '@Components/Layout/Search/Components/InputSearch';
import InputSearchMobile from '@Components/Layout/Search/Components/InputSearch/SearchMobile';

// Styles
import styles from './Layout.module.scss';

export interface LayoutProps extends InputSearchProps {
    className?: string;
    onClickFilter?: () => void;
    onSearch?: (keyword: string) => void;
}

const Layout: FunctionComponent<LayoutProps> = ({
    children,
    className,
    ...props
}) => {
    const { deviceType } = useViewDetected();

    const wrapperClassName = classnames([
        styles.wrapper,
        {
            [styles.mobile]: ['mobile', 'tablet'].includes(deviceType),
        },
        className,
    ]);

    return (
        <Page className={wrapperClassName}>
            <ViewMedia is={['mobile', 'tablet']}>
                <InputSearchMobile {...props} className={styles.search} />
            </ViewMedia>
            {children}
        </Page>
    );
};

Layout.defaultProps = {
    type: '',
    className: '',
    placeholder: 'Tìm bệnh, Bác sĩ, hỏi đáp, phòng khám',
    onSearch: (keyword) => keyword,
};

export default Layout;
